(function () {
  'use strict';

  async function initAddons() {
    var widgets = document.querySelectorAll('.sobooth-addons');
    if (!widgets.length) return;

    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      var buttons = widget.querySelectorAll('.sobooth-addons__btn[data-handle]');
      for (var j = 0; j < buttons.length; j++) {
        var btn = buttons[j];
        var handle = btn.dataset.handle;
        if (handle) {
          try {
            var res = await fetch('/products/' + handle + '.js');
            var data = await res.json();
            btn.dataset.variantId = data.variants[0].id;
            btn.dataset.price = data.variants[0].price;
          } catch (err) {
            console.error('Erreur produit:', handle, err);
          }
        }
      }
      updateSummary(widget);
      setupButtons(widget);
    }

    hookATC();
  }

  function setupButtons(widget) {
    widget.querySelectorAll('.sobooth-addons__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.sobooth-addons__group');
        group.querySelectorAll('.sobooth-addons__btn').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        updateSummary(document.querySelector('.sobooth-addons'));
      });
    });
  }

  function hookATC() {
    var atcBtn = document.querySelector('.product-form__submit[name="add"]')
      || document.querySelector('button[name="add"]');

    if (!atcBtn || atcBtn.dataset.soboothHooked) return;
    atcBtn.dataset.soboothHooked = 'true';

    atcBtn.addEventListener('click', function() {
      // Collecter les add-ons sélectionnés AU MOMENT DU CLIC
      var selectedItems = getSelectedAddons();
      
      if (selectedItems.length === 0) return;

      // Attendre que Dawn ait fini son ajout, puis ajouter les add-ons
      setTimeout(function() {
        addAddonsToCart(selectedItems);
      }, 1500);
    });
  }

  function getSelectedAddons() {
    var widget = document.querySelector('.sobooth-addons');
    if (!widget) return [];

    var items = [];
    widget.querySelectorAll('.sobooth-addons__group').forEach(function(group) {
      var activeBtn = group.querySelector('.sobooth-addons__btn.is-active');
      if (activeBtn
        && activeBtn.dataset.value !== 'none'
        && activeBtn.dataset.variantId
        && activeBtn.dataset.variantId !== '') {
        items.push({ id: parseInt(activeBtn.dataset.variantId), quantity: 1 });
      }
    });
    return items;
  }

  async function addAddonsToCart(items) {
    if (!items || items.length === 0) return;

    var cartAddUrl = (window.routes && window.routes.cart_add_url)
      ? window.routes.cart_add_url
      : '/cart/add';

    try {
      var res = await fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (res.ok) {
        // Rafraîchir le cart drawer de Dawn
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch(window.routes.cart_url + '?sections=cart-drawer')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data['cart-drawer']) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
                var newDrawer = doc.querySelector('#CartDrawer');
                var currentDrawer = document.querySelector('#CartDrawer');
                if (newDrawer && currentDrawer) {
                  currentDrawer.innerHTML = newDrawer.innerHTML;
                }
              }
            });
        }
      } else {
        var err = await res.json();
        console.error('Erreur add-ons:', err);
      }
    } catch (err) {
      console.error('Erreur réseau:', err);
    }
  }

  function updateSummary(widget) {
    if (!widget) return;
    var total = 0;
    widget.querySelectorAll('.sobooth-addons__btn.is-active').forEach(function(btn) {
      total += parseInt(btn.dataset.price || 0, 10);
    });
    var display = widget.querySelector('.sobooth-addons__summary-price');
    if (display) {
      display.textContent = total > 0
        ? '+' + (total / 100).toFixed(0) + ' \u20ac'
        : '\u2014';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddons);
  } else {
    initAddons();
  }

  document.addEventListener('shopify:section:load', function() {
    initAddons();
  });

})();